import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import CheckBoxViewModelType from '@/ViewModels/Controls/CheckBoxViewModel';
import CheckBoxType from '@/Controls/CheckBox';
import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';

export default class CheckBoxFactory extends ControlFactory {

    /**
     *  @override
     */
    control: CheckBoxType;
    private CheckBoxViewModel = ComponentManager.getViewModel<typeof CheckBoxViewModelType>('CheckBoxViewModel');
    private CheckBox = ComponentManager.getControl<typeof CheckBoxType>('CheckBox');

    /**
     *  @override
     */
    public viewModel: CheckBoxViewModelType;
    protected jQueryControl: JQuery<HTMLElement>;

    public constructor(params) {
        super(params);
    }

    /**
     *  @override
     */
    public getControl(): JQuery<HTMLElement> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.createViewModel(this.createViewModelParamater());

        this.control = this.createControl(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }

    protected createViewModelParamater(): any {
        let params = {
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            invalidationText: this.invalidationText,
            isSummaryViewMode: this.isSummaryViewMode,
            isChecked: this.context.genericObject.getObservable(this.detailViewItem.name),
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            })
        };

        if (this.detailViewItem.useInFilter) {
            $.extend(params, {
                value: this.context.genericObject.getObservable(this.detailViewItem.name, false)
            });
        }

        return params;
    }

    protected createViewModel(parameter: any): CheckBoxViewModelType {
        return new this.CheckBoxViewModel(parameter);
    }

    protected createControl(viewModel: CheckBoxViewModelType): CheckBoxType {
        return new this.CheckBox(this.viewModel);
    }

    public getValueForFilter(): any {
        const ret = {};
        ret[this.detailViewItem.name] = this.context.genericObject.getValue(this.detailViewItem.name);
        return ret;
    }

    public getFilterInfo(): any {
        return {
            field: this.detailViewItem.name,
            value: this.getValueAsString()
        }
    }

    private getValueAsString() {
        if(!this.viewModel)
            return '';
        
        return this.viewModel.isChecked() ? 'true' : 'false';
    }
}

ComponentManager.setFactory('CheckBox', CheckBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');